/**
 * Formulator engine error codes (epic PI-SPEC-SW-E282, contract formulator 1).
 *
 * What the SpecTree Toolbox formulator engine reports when it cannot start a
 * session or finish a turn. The bridge returns them on failed actions and the
 * `turn-finished` event carries them; SpecTree pages map them to plain
 * messages. A failed turn posts nothing to SpecTree, so the person's typed
 * reply is kept and can be sent again.
 */
/** Every code the formulator engine reports. */
export const FORMULATOR_ENGINE_ERROR_CODES = [
    "CLAUDE_NOT_INSTALLED",
    "CLAUDE_NOT_SIGNED_IN",
    "PLUGIN_MISSING",
    "MCP_NOT_CONNECTED",
    /** The project has no repository mapped; a board auditor maps one on the Repos page. */
    "REPO_NOT_MAPPED",
    /** Git needs a sign-in for a mapped repository; the message names it. */
    "REPO_AUTH_REQUIRED",
    /** A mapped repository could not be cloned or fetched; the message names it. */
    "REPO_CLONE_FAILED",
    "USAGE_LIMIT",
    "TURN_TIMEOUT",
    /** Claude finished without a valid `SPECTREE_FORMULATOR_TURN` line for this session. */
    "NO_TURN_RETURNED",
    "SESSION_NOT_FOUND",
    /** The app is already running a turn; one Claude run at a time. */
    "BUSY",
    "NETWORK",
    "UNKNOWN",
];
/** True when `value` is a formulator engine error code. */
export function isFormulatorEngineErrorCode(value) {
    return typeof value === "string" && FORMULATOR_ENGINE_ERROR_CODES.includes(value);
}
//# sourceMappingURL=errors.js.map